/* eslint-disable react/jsx-no-useless-fragment */
import { Drawer, Text, TextLink } from '@cinch-labs/design-system'
import { useMarshallExplanationDrawer } from './marshall-explanation-drawer.context'

export const MarshallExplanationDrawer = () => {
  const { setShowMarshallExplanationDrawer, showMarshallExplanationDrawer } =
    useMarshallExplanationDrawer()

  const handleClick = () => {
    setShowMarshallExplanationDrawer(!showMarshallExplanationDrawer)
  }

  return (
    <>
      {showMarshallExplanationDrawer && (
        <Drawer
          onClose={() => handleClick()}
          header={'cinch & Marshall Motor Group'}
          ariaLabelledById="marshall-explanation-drawer"
        >
          <Text fontSizeFixed="m">
            We've partnered with Marshall Motor Group - one of the biggest names
            in the car industry - to offer faff-free servicing and MOTs to all
            drivers. We service petrol, diesel, hybrid and electric cars - any
            make, any model.
          </Text>
          <br></br>
          <br></br>
          <Text fontSizeFixed="m">
            Marshall has over 100 servicing centres across the country and is
            powered by 115 years of motoring know-how. Your car's in safe hands.
          </Text>
          <br></br>
          <br></br>
          <Text fontSizeFixed="m">
            See our{' '}
            <TextLink
              href="https://www.cinch.co.uk/car-care/servicing"
              target="_blank"
              rel="nofollow noreferrer"
            >
              servicing page
            </TextLink>{' '}
            for details.{' '}
            <TextLink
              href="https://nd-mediagallery2-public-production.s3.amazonaws.com/735302732a279995615f915662374b19/260602_cinchservicing_at_marshall_terms_and_conditions.pdf"
              target="_blank"
              rel="nofollow noreferrer"
            >
              Terms and exclusions
            </TextLink>{' '}
            apply.
          </Text>
        </Drawer>
      )}
    </>
  )
}

export default MarshallExplanationDrawer
